import type { AppsSdksSignalSelection } from "app/pages/sales-intelligence/domain/signals/types/apps-signal";
import type { SignalSdksFilterProps } from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalSdksFilter/SignalSdksFilter";
import SignalSdksFilter from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalSdksFilter/SignalSdksFilter";
import { buildSdksTrackingValue } from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-filters/helpers";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

type Props = SignalSdksFilterProps & {
    signalAlias: string;
};

const SignalSdksFilterTracked = (props: Props) => {
    const handleTrackedChange = (updatedValue: AppsSdksSignalSelection) => {
        const trackingValue = buildSdksTrackingValue(updatedValue);

        trackingService.filters.trackSdkFilterChange(trackingValue, props.signalAlias);
        props.onValueChange(updatedValue);
    };

    return (
        <SignalSdksFilter
            {...props}
            onValueChange={handleTrackedChange}
        />
    );
};

export default SignalSdksFilterTracked;
